import React from "react";

const SpotRender = ({ row }) => {
  return <div>{row.spot ? row?.spot : "-"}</div>;
};

export default SpotRender;
